import styled from "styled-components";

export const ContainerRememberMe = styled.div`
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 12px;

  #inputRememberMe {
    height: 15px;
    margin-left: 12px;
  }
`;
